import { render, staticRenderFns } from "./jifenlog.vue?vue&type=template&id=15f666c4&"
import script from "./jifenlog.vue?vue&type=script&lang=js&"
export * from "./jifenlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports